export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        labelComputed() {
            return this.required ? `${this.label} (rerquired)` : this.label;
        },
    },
};
